export enum StoreStatus {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  DONE = 'DONE',
  FAILED = 'FAILED',
}
